module.exports = __webpack_public_path__ + "img/imagen_parrafo_cuatro.bd5ee000.jpg";